import { writable } from 'svelte/store';
let ModalShown = null;
const { subscribe, update, set } = writable(ModalShown);
const modal = {
    subscribe,
    update,
    set
};
export default modal;
